import { Card } from '@blueprintjs/core';
import React from 'react';
import { SemesterDutyCounters, SemesterDutyCountersProps } from './SemesterDutyCounters';

export interface DutyCountersProps {
  semester1DutyCounters: SemesterDutyCountersProps;
  semester2DutyCounters: SemesterDutyCountersProps;
}

export const DutyCounters = ({ semester1DutyCounters, semester2DutyCounters }: DutyCountersProps) => {
  return (
    <Card
      style={{
        margin: 5,
        padding: 5,
      }}
    >
      <SemesterDutyCounters {...semester1DutyCounters} semesterNumber={1} />
      <SemesterDutyCounters {...semester2DutyCounters} semesterNumber={2} />
    </Card>
  );
};
